import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const PricePanel = styled.div`
  margin-bottom: 20px;

  ${media.mediumUp`
    margin-bottom: 30px;
`}
`;
